import { BottomSheet } from "@Light/components/page/BottomSheet";
import { Button } from "@Light/components/page/Button";
import { MutationButton } from "@Light/components/page/MutationButton";
import type { AddressSearchResponse } from "@Light/services/lightTypes";
import React from "react";
import { useEnrollment } from "../flow/context";
import { AddressCard } from "./AddressCard";

export type ConfirmAliasBottomSheetProps = {
  open: boolean;
  address: AddressSearchResponse | undefined;
  onConfirm: () => void;
  onClose: () => void;
};

export const ConfirmAliasBottomSheet: React.FC<
  ConfirmAliasBottomSheetProps
> = ({ open, address, onConfirm, onClose }) => {
  const { nextMutation } = useEnrollment();

  return (
    <BottomSheet open={open} onClose={onClose}>
      {address && (
        <div className="flex flex-col gap-6 px-4 pt-4 pb-6">
          <div className="flex flex-col gap-1">
            <div className="text-lg font-semibold text-primary pr-10">
              Your address differs for utilities.
              <br />
              Does this look right?
            </div>
            <div className="text-sm text-tertiary">
              Mailing addresses can differ from service addresses because of the
              building&rsquo;s location.
            </div>
          </div>

          <AddressCard
            address={address}
            label="Mailing address"
            line1={address.alias}
            data-testid="confirm-alias-mailing"
          />
          <AddressCard
            address={address}
            label="Service address"
            diffAgainst={address.alias}
            data-testid="confirm-alias-service"
          />

          <div className="flex flex-col gap-2">
            <MutationButton
              size="lg"
              mutation={nextMutation}
              mutate={onConfirm}
              mutateButtonText="Yes, view offer"
              errorMessage="Failed to save your address. Please try again."
              data-testid="confirm-alias-yes"
            />
            <Button
              size="lg"
              buttonType="clear"
              className="w-full"
              onClick={onClose}
              data-testid="confirm-alias-no"
            >
              No, provide different address
            </Button>
          </div>
        </div>
      )}
    </BottomSheet>
  );
};
